// opervex-frontend/src/services/AlertService.js

let callback = null;

const AlertService = {
  register(cb) {
    callback = cb;
  },
  Error(messages) {
    if (callback) {
      callback({ messages, variant: "danger" });
    }
  },
  Success(messages) {
    if (callback) {
      callback({ messages, variant: "success" });
    }
  },
  Warning(messages) {
    if (callback) {
      callback({ messages, variant: "warning" });
    }
  },
  Info(messages) {
    if (callback) {
      callback({ messages, variant: "info" });
    }
  },
  Clear() {
    if (callback) {
      callback({ messages: [], variant: "danger" });
    }
  },
};

export default AlertService;
